// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Iq","link":"e_Jq","imageContainer":"e_Kq","author":"e_Lq","text":"e_Mq","buttonIcon":"e_Nq"};